require('./transferEmitter.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { HYPHEN } = require('constants/index');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKInput } = require('commonsComponents/OKInput');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @actions
const intervenersActions = require('actions/getAccountInterveners');

class TransferEmitter extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        const { accountId, requestInterveners, resetInterveners, setEmitter, loadOldEmitter } = this.props;

        if (!!nextProps.accountId) {
            if (nextProps.accountId !== accountId) {
                if (!!accountId) {
                    // we clear old interveners to avoid affecting other views that use interveners too
                    resetInterveners(accountId);
                    if (!!nextProps.emitter) {
                        // we clear old emitter selected if any
                        setEmitter('');
                    }
                }
                requestInterveners(nextProps.accountId, true); //filter user logged in
            }
        } else if (!!nextProps.emitter) {
            // no account is selected and an emitter was selected
            setEmitter('');
        }

        // when reusing transfer or editing scheduled, detect if old emitter is user logged-in or unexisting emmiter
        // if so, we delete it
        if (!!nextProps.oldEmitter) {
            const intervenersFetchSuccess = nextProps.immAccounts.getIn([nextProps.accountId,'interveners', 'fetchSuccess']);
            if (intervenersFetchSuccess) {
                const immInterveners = nextProps.immAccounts.getIn([nextProps.accountId,'interveners', 'list']);
                if (immInterveners.size > 0) {
                    const hasEmitter = immInterveners.find(immIntervener => {
                        const immIdentification = immIntervener.get('identification');
                        const intervener = `${immIdentification.get('type')}${HYPHEN}${immIdentification.get('code')}`;
                        return intervener === nextProps.oldEmitter;
                    });

                    if (hasEmitter) {
                        loadOldEmitter(nextProps.oldEmitter);
                    } else {
                        loadOldEmitter('');
                    }
                } else {
                    loadOldEmitter('');
                }
            }
        }
    }

    buildTransferEmitterSection(immAccount) {
        const { emitter, setEmitter } = this.props;
        const immInterveners = immAccount.getIn(['interveners', 'list']);

        let emitterContent;

        if (immAccount.getIn(['interveners', 'isLoading'])) {
            emitterContent = <LoadingSection />;
        } else if (immInterveners.size > 0) {
            const intervenersOptions = immInterveners.map( immIntervener => {
                const immIdentification = immIntervener.get('identification');
                return {
                    value: `${immIdentification.get('type')}${HYPHEN}${immIdentification.get('code')}`,
                    label: `${immIntervener.get('name')} (${immIntervener.get('type')})`
                }
            }).toJS();

            if (!!emitter) {
                const transferEmitterLabel = formatText('transferSummary-step1SelectTransferPayer');

                emitterContent = (
                    <div>
                        <OKSelect
                            label={transferEmitterLabel}
                            options={intervenersOptions}
                            value={emitter}
                            tooltipContent="transferSummary-step1TransferPayerHintDescription"
                            tooltipTitle="transferSummary-step1TransferPayerHintTitle"
                            searchable={false}
                            clearable={false}
                            onChange={(item) => {
                                if (!!item.value) {
                                    setEmitter(item.value);
                                }
                            }}
                        />
                        <OKButton
                            modifier="ghost"
                            onClick={() => {
                                setEmitter(); //clear emitter
                            }}
                            leftIcon="icon-quitar"
                        >
                            {formatText("transferSummary-step1RemoveTransferPayer")}
                        </OKButton>
                    </div>
                );
            } else {
                emitterContent = (
                    <OKButton
                        modifier="ghost"
                        onClick={() => {
                            setEmitter(intervenersOptions[0].value); //choose default emitter as first intervener
                        }}
                        leftIcon="icon-agregar"
                    >
                        {formatText("transferSummary-step1AddTransferPayer")}
                    </OKButton>
                );
            }
        }

        return (
            <div className="transfer-first-step__form-section">
                {emitterContent}
            </div>
        );
    }

    render() {
        const { immAccounts, accountId, transferPayerName } = this.props;
        let content = (<div></div>);

        if (!!accountId) {
            const immAccount = immAccounts.get(accountId);
            const transferPayerLabel = formatText('transferSummary-step2TransferEmitter');
            const interventionType = formatText(`interventionTypes-${immAccount.get('interventionType')}`);
            const transferPayer = `${transferPayerName} (${interventionType})`;

            const transferEmitterSection = this.buildTransferEmitterSection(immAccount);

            content = (
                <div className="transfer-emitter">
                    <div className="transfer-first-step__form-section">
                        <OKInput
                            label={transferPayerLabel}
                            value={transferPayer}
                            disabled
                        />
                    </div>
                    {transferEmitterSection}
                </div>
            );
        }

        return content;
    }
}

TransferEmitter.propTypes = {
    accountId: PropTypes.string,
    emitter: PropTypes.string,
    oldEmitter: PropTypes.string,
    immAccounts: PropTypes.object,
    immProfile: PropTypes.object,
    requestInterveners: PropTypes.func.isRequired,
    resetInterveners: PropTypes.func.isRequired,
    setEmitter: PropTypes.func.isRequired,
    loadOldEmitter: PropTypes.func.isRequired,
    transferPayerName: PropTypes.string
};

module.exports.constructor = TransferEmitter;
module.exports.TransferEmitter = connect(null, {
    requestInterveners: intervenersActions.requestAccountInterveners,
    resetInterveners: intervenersActions.resetAccountInterveners
})(TransferEmitter);
